import { AlertTriangle, ExternalLink } from 'lucide-react';
import type { DublettenTreffer } from '@/lib/dubletten';

const GRUND_TEXT: Record<DublettenTreffer['grund'], string> = {
  weitere_offene_akte: 'weitere offene Mietwagen-Akte',
  ueberlappender_zeitraum: 'überlappender Mietzeitraum',
};

export default function DublettenWarnBanner({
  treffer,
  onOpen,
}: {
  treffer: DublettenTreffer[];
  onOpen?: (id: string) => void;
}) {
  if (treffer.length === 0) return null;

  return (
    <div
      data-testid="dubletten-warnbanner"
      role="alert"
      className="rounded-lg border border-amber-300 bg-amber-50 p-3 flex items-start gap-3 text-amber-900"
    >
      <AlertTriangle className="w-5 h-5 text-amber-700 shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0 text-sm">
        <p className="font-semibold">
          {treffer.length === 1
            ? 'Möglicher Dublettenfall für diesen Kunden'
            : `Möglicher Dublettenfall (${treffer.length} weitere Akten)`}
        </p>
        <p className="mt-0.5 text-amber-800">
          Kunde hat {treffer.length === 1 ? 'eine' : `${treffer.length}`}{' '}
          {GRUND_TEXT[treffer[0].grund]}
          {treffer.length > 1 ? ' (u. a.)' : ''} — bitte Zuordnung prüfen.
        </p>
        <ul className="mt-2 space-y-1">
          {treffer.map((t) => (
            <li key={t.id}>
              <button
                type="button"
                data-testid={`dubletten-link-${t.id}`}
                onClick={() => onOpen?.(t.id)}
                className="inline-flex items-center gap-1 text-amber-900 font-medium underline underline-offset-2 hover:text-amber-950 focus:outline-none focus:ring-2 focus:ring-amber-500 rounded"
              >
                {t.akten_nr || 'Ohne Nr.'} ({GRUND_TEXT[t.grund]})
                <ExternalLink className="w-3 h-3" />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
